import React, { useContext, createContext } from 'react';

var PlacementContext = /*#__PURE__*/createContext(undefined);
var PlacementProvider = function PlacementProvider(_ref) {
  var children = _ref.children,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'page' : _ref$placement;
  return /*#__PURE__*/React.createElement(PlacementContext.Provider, {
    value: placement
  }, children);
};
function usePlacement() {
  var context = useContext(PlacementContext);
  if (context === undefined) {
    // Not being used within a <PlacementProvider> so just default to
    // 'page'.
    return 'page';
  }
  return context;
}

export { PlacementProvider, usePlacement };
